export default "__VITE_ASSET__CmMMG19A__"